import React, { Component } from 'react';

export class SOList extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        var nametagSOList = this.props.nametagSOList;
        var startApprovalProcessFunction = this.props.startApprovalProcess;
        console.log("SOList", nametagSOList)
        return (
            <div className="nametag-so-list">
                <table className="nametag-so-list-table">
                    <thead>
                        <tr>
                            <td>SO Number</td>
                            <td>Customer</td>
                            <td>Order Date</td>
                            <td>Review</td>
                        </tr>
                    </thead>
                    <tbody>
                        {nametagSOList.map(function (SOInfo, idx) {
                            console.log("SOINFO", SOInfo);
                            var className = "";
                            if (SOInfo.viewed) {
                                className = "nametag-so-viewed"
                            }
                            if (!SOInfo.approved) {
                                return (
                                    <tr key={idx} className={className}>
                                        <td><a href={SOInfo.SOUrl} target="_blank">{SOInfo.SONum}</a></td>
                                        <td>{SOInfo.customerName}{SOInfo.orderHasIssue && <span className="order-has-issue">*</span>}</td>
                                        <td>{SOInfo.orderDate}</td>
                                        <td><button onClick={() => { startApprovalProcessFunction(SOInfo.SOId) }}>Review</button></td>
                                    </tr>
                                )
                            }
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}